export default __webpack_public_path__ + "static/1168-a5987fb38a5eac3736cb89caac1be964.gif";